import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { TemplateMedicineTypeService } from 'src/app/shared/services/API/pharmacy/template-medicine-type.service';

@Component({
  selector: 'app-template-type-delete-modal',
  templateUrl: './template-type-delete-modal.component.html',
  styleUrls: ['./template-type-delete-modal.component.css']
})
export class TemplateTypeDeleteModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
  public dialog: MatDialog, 
  public matDialogRef: MatDialogRef<TemplateTypeDeleteModalComponent>,
  private templateMedicineTypeService: TemplateMedicineTypeService,
  private alertService: AlertService) { }

  public isLoading:boolean;  

  ngOnInit(): void {
    this.isLoading = false;
  }
  
  close(){
    this.matDialogRef.close({deleteMedicineType: false}); 
  }
  
  clickDelete(){
    
    this.isLoading = true;

    this.templateMedicineTypeService.deleteTemplateMedicineType(this.data.idMedicineType).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.alertService.show('Sucesso', "Tipo de medicamento excluido com sucesso!", AlertType.success); 
      this.matDialogRef.close({deleteMedicineType: true}); 
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }
  
  clickCancel(){
    this.matDialogRef.close({deleteMedicineType: false}); 
  }
}
